var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayPlaylist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.023 12.582v-5.12a.417.417 0 01.648-.348l3.842 2.56a.417.417 0 010 .695l-3.842 2.558a.42.42 0 01-.23.073.418.418 0 01-.418-.418zM.418 7.517a.418.418 0 010-.835h5.846a.418.418 0 010 .835H.418zm0-3.34a.418.418 0 010-.836h14.199a.418.418 0 010 .835H.417zm0-3.342a.418.418 0 010-.835h14.199a.418.418 0 010 .835H.417z",
    fill: "#7A8D8F"
  })));
}
export default SvgPlayPlaylist;